import React, { useCallback } from 'react';
// import { getWallet, getFPPWallet } from '../../../store/selectors';
// import { useSelector } from 'react-redux';
import { formatCurrency } from '../../../../helpers/format';
import Chips from '../../../Club/ChipBalance/Chips';



const TournamentLowBalanceMessage = ({data, message, onClose, onDeposit, t}) => {

    const {currency, buyin, payWithFPP, buyinFPP} = data;

    // const {balance: balanceMain} = useSelector(getWallet);
    // const {balance: balanceFPP} = useSelector(getFPPWallet);

    const openDepositDialog = useCallback(() => {
        onDeposit();
        onClose();
    }, []);
    return (
        <React.Fragment>
            <div className="tournament__low-balance__title">
                <span className="tournament__low-balance__text">{message}</span>
            </div>
            <div className="tournament__low-balance__balance-info-wrapper">
                <div className="tournament__low-balance__balance-info">
                    <span className="tournament__low-balance__balance-info-text">{`${t('price')}:`}</span>
                    {!payWithFPP&& <span className="tournament__low-balance__balance-info-value">{formatCurrency(buyin, null, currency)}</span>}
                    {payWithFPP && <Chips val={buyinFPP} />}
                </div>
                <div className="tournament__low-balance__balance-info main-balance">
                    <span className="tournament__low-balance__balance-info-text">{`${payWithFPP ? t('coinBalance') : t('mainBalance')}:`}</span>
                    {!payWithFPP &&<span className="tournament__low-balance__balance-info-value">
                        CHIPCHIP
                        </span>}
                    {/* {payWithFPP && <Coins val={balanceFPP} />} */}
                </div>
            </div>
            <div className="tournament__low-balance__buttons-wrapper">
                {!payWithFPP && <button className="tournament__low-balance__button-deposit tournaments__buttons__button" onClick={() => openDepositDialog()}>{t('deposit')}</button>}
                <button className="tournament__low-balance__button-close" onClick={() => onClose()}>{!payWithFPP ? t('cancel'): t('close') }</button>
            </div>
        </React.Fragment>
    )
}

export default TournamentLowBalanceMessage;